// extracted by mini-css-extract-plugin
export default {"cursorDot":"CustomCursor_cursorDot__RKUSp","cursorRing":"CustomCursor_cursorRing__gk4kx","hovering":"CustomCursor_hovering__kGXfn"};